import React, { useState } from "react";
import { Select, Grid } from "@mui/material";
import { TextField, MenuItem, FormControl, InputLabel } from "@mui/material";
import { InputAdornment, styled, Box, Button, Stack } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { DialogTitle, SubTitle } from "./styles";
import { saveVehicle } from "./httpCalls";
import { vehicleAdded } from "./vehicleSlice";
import { Toast } from "../components/Toast";
import { useDispatch } from "react-redux";

const Input = styled(TextField)({
  height: "56px",
  background: "#F8F8F8",
  borderRadius: "4px",
});

function AddVehicle({ onClose }) {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    vehicleName: "",
    numberPlate: "",
    fuelAverage: "",
    driverName: "",
    fuelPrice: "",
    fuelType: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const submit = async () => {
    try {
      onClose();
      dispatch(vehicleAdded(state));
      saveVehicle(state, dispatch);
    } catch (err) {
      console.log("err:", err);
      Toast("error", "Error");
    }
  };

  return (
    <Box sx={{ background: "#FFFFFF", borderRadius: "20px" }}>
      <DialogTitle>Add Vew Vehicle Expense</DialogTitle>
      <SubTitle>This information can be edited later.</SubTitle>
      <Grid container spacing={2} marginTop="3%">
        <Grid item md={6} xs={12}>
          <Input
            variant="outlined"
            fullWidth
            label="Vehicle Name"
            name="vehicleName"
            value={state.vehicleName}
            onChange={handleInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CancelIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Input
            variant="outlined"
            fullWidth
            label="Vehicle Number"
            name="numberPlate"
            value={state.numberPlate}
            onChange={handleInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CancelIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Input
            variant="outlined"
            fullWidth
            label="Fuel Average/liter"
            name="fuelAverage"
            value={state.fuelAverage}
            onChange={handleInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CancelIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Input
            variant="outlined"
            fullWidth
            label="Driver Name"
            name="driverName"
            value={state.driverName}
            onChange={handleInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CancelIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Input
            variant="outlined"
            fullWidth
            label="Fuel Price"
            name="fuelPrice"
            value={state.fuelPrice}
            onChange={handleInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CancelIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Fuel Type</InputLabel>
            <Select
              label="Fuel Type"
              name="fuelType"
              defaultValue=""
              onChange={handleInput}
              sx={{
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
            >
              <MenuItem value="Petrol">Petrol</MenuItem>
              <MenuItem value="Diesel">Diesel</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Stack
        width="100%"
        direction="row"
        justifyContent="space-around"
        margin="5% 0px"
      >
        <Button
          sx={{
            width: "25%",
            color: "#A7A7A7",
            background: "#F8F8F8 !important",
          }}
          variant="contained"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button sx={{ width: "25%" }} variant="contained" onClick={submit}>
          Save
        </Button>
      </Stack>
    </Box>
  );
}

export default AddVehicle;
